/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { computed } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import { makeArray } from "discourse/lib/helpers";
import selectKitPropUtils from "select-kit/lib/select-kit-prop-utils";
import { precompileTemplate } from "@ember/template-compilation";
const FormatSelectedContent = dt7948.c(class FormatSelectedContent extends Component {
  content = null;
  selectKit = null;
  get formattedContent() {
    if (this.content) {
      return makeArray(this.content).map(c => this.getName(c)).join(", ");
    } else {
      return this.getName(this.selectKit.noneItem);
    }
  }
  static {
    dt7948.n(this.prototype, "formattedContent", [computed("content")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <span class=\"formatted-selection\">\n      {{this.formattedContent}}\n    </span>\n  ", {
      strictMode: true
    }), this);
  }
}, [selectKitPropUtils, tagName("")]);
export default FormatSelectedContent;